import { ModalMessagerService } from './../../../../../modal-messager/modal-messager.service';
import { Component, OnInit } from '@angular/core';
import { text } from 'd3';

@Component({
  selector: 'app-wms-config',
  templateUrl: './wms-config.component.html',
  styleUrls: ['./wms-config.component.scss']
})
export class WmsConfigComponent implements OnInit {

  constructor(private messager: ModalMessagerService) { }

  ngOnInit(): void {
  }
  GetFile() {
    this.messager.RequestImport({ acceptedExtentions: ['kml'], readType: 'string', encoding: 'text' }, 'Select a KML file', (data: any) => {
      const records = this.ParseKML(data.contents);
      this.SaveRecords(records);
    });
  }
  SaveRecords(records: Array<any>) {
    this.messager.RequestExport({
      extension: 'csv', mimeType: 'text/comma-separated-values',
      contents: records.join("\n"), defaultFileName: 'out'
    }, 'Save Records', () => { }, () => { });
  }
  ParseKML(kml: string): Array<any> {
    const doc = $.parseXML(kml);
    console.log(doc);
    const placeMarks = doc.getElementsByTagName('Placemark');
    console.log(placeMarks);
    let maxImgs = 0;
    const delim = ',';
    const heading = ['id', 'northing', 'easting', 'elevation', 'description','units', 'img_1_path_before','img_1_before', 'img_1_path_after','img_1_after', 'img_2_path_before','img_2_before', 'img_2_path_after', 'img_2_after'];
    const records = [];
    records.push(heading.join(delim));
    for (let i = 0; i < placeMarks.length; i++) {
      const placeMark = placeMarks[i];
      const name = $('name', placeMark).text();
      const id = name.match(/[\d]+/)[0];
      let description = $($('description', placeMark).text());//.html().replace(']]&gt;','');
      const rows = $('tr', description);
      const northing = $('td', rows[1])[1].innerText.split(' ');
      const easting = $('td', rows[2])[1].innerText.split(' ');
      const elevation = $('td', rows[3])[1].innerText.split(' ');
      let record = `${id}${delim}${northing[0]}${delim}${easting[0]}${delim}${elevation[0]}${delim}${name}${delim}${northing[1]}`;
      const imgs = $('img', description);
      let imgPath = [];
      let imgBefore = [];
      let imgAfter = [];
      for (let img_i = 0; img_i < imgs.length; img_i++) {
        const src = $(imgs[img_i]).attr('src').split('/');
        const srcName = src.pop();
        imgPath[img_i] = src.join('/');
        imgBefore[img_i] = srcName;

        const ext = srcName.split('.').pop();
        imgAfter[img_i] = id + '_' + (img_i + 1) + ext;
      }
      record += delim + imgPath[0] +delim+ imgBefore[0] + delim + delim+ imgAfter[0];
      if (imgBefore.length > 1) {
        record += delim + imgPath[1]+ delim + imgBefore[1] + delim + delim + imgAfter[1];
      } else {
        record += delim + delim + delim + delim;
      }
      records.push(record);
    }
    return records;
  }
}
